export default {"src":"/_next/static/media/cart-black.82d9f8c1.svg","height":48,"width":56};